import { createFileRoute, Outlet } from "@tanstack/react-router";

/** Legal documents: every version, a new one, and one version's page. */
export const Route = createFileRoute("/_app/growth/legal")({
  component: Outlet,
});
